<template>
  <div class="licenza">
    <h1>La licenza è scaduta, collegati al sito per rinnovarla ...</h1>
    <img :src="`${publicPath}img/ubisell-logo.png`" >
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>

<style scoped>
  .licenza {
    display: block;
    width: 100vw;
    height: 100vh;
    text-align: center;
    box-sizing: border-box;
    padding-top: 20vh;
  }
</style>
